import * as React from "react";
const SvgFiRrSquareK = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-k_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM17.743 6.669l-3.989 4.433 4.087 6.358a1 1 0 0 1-1.682 1.082l-4.205-6.541H7.999v6a1 1 0 1 1-2 0V6a1 1 0 1 1 2 0v4h4.055l4.202-4.669a1 1 0 0 1 1.487 1.338"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-k_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareK;
